import { useState } from 'react';

export default function useWarningFormModal() {
  const [isExpirationTimeValid, setIsExpirationTimeValid] = useState(true);
  const updateExpirationTime = (
    expirationTime: string,
    setExpirationTime: (v: number) => void,
  ) => {
    const newExpirationTime = Number(expirationTime);
    if (!Number.isNaN(newExpirationTime)) {
      setExpirationTime(newExpirationTime);
      if (newExpirationTime < 1) {
        setIsExpirationTimeValid(false);
      } else {
        setIsExpirationTimeValid(true);
      }
      if (newExpirationTime <= 0) {
        setExpirationTime(0);
      }
    }
  };

  return {
    updateExpirationTime,
    isExpirationTimeValid,
  };
}
